// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace SupportActions {
  export class SendSupportEmail {
    static readonly type = '[SUPPORT] Send Support Email';
    constructor(public body: string) {}
  }
}
